import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-active",
  "use": "icon-active-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-active\"><path d=\"M4.87619 87.771429v794.819047h541.257143v-97.523809H102.4V185.295238h819.2v297.447619h97.52381V87.771429z\" p-id=\"2167\" /><path d=\"M668.038095 214.552381l-195.047619 229.180952-151.161905-97.523809-185.295238 234.057143 73.142857 63.390476L341.333333 477.866667l151.161905 92.647619 248.685714-292.571429zM892.342857 536.380952h-263.314286v399.847619h97.52381v-136.533333h87.771429v43.885714h204.8v-263.314285h-126.780953V536.380952z m48.761905 121.904762v107.276191h-48.761905v-43.885715h-165.790476v-107.27619h87.771429v43.885714h126.780952z\" p-id=\"2168\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/active.svg
// module id = MWzP
// module chunks = 111